export const STYLE_GUIDE_BETA_ENROLLMENT_PATH = "/app/style-guide-beta";

export function normalizeStyleGuideBetaCampaign(value) {
  return typeof value === "string" && /^[a-zA-Z0-9_.-]{1,64}$/.test(value) ? value : "style-guide-beta";
}

export function isStyleGuideBetaEnrollmentPath(pathname) {
  return pathname === STYLE_GUIDE_BETA_ENROLLMENT_PATH || pathname === `${STYLE_GUIDE_BETA_ENROLLMENT_PATH}/`;
}

// Keep the email-login return destination local and limited to this enrollment flow.
export function styleGuideBetaSignInNext(pathname, search) {
  if (!isStyleGuideBetaEnrollmentPath(pathname)) return undefined;
  const campaign = normalizeStyleGuideBetaCampaign(new URLSearchParams(search).get("campaign"));
  return `${STYLE_GUIDE_BETA_ENROLLMENT_PATH}?campaign=${campaign}`;
}
